var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgKickerSquares = function SvgKickerSquares(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#3D50FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 5,
    y: 5,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#D80C9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 10,
    y: 9,
    width: 14,
    height: 14,
    rx: 1,
    fill: "#05A1C9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKickerSquares);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjUgMjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iMSIgeT0iMSIgd2lkdGg9IjgiIGhlaWdodD0iOCIgcng9IjEiIGZpbGw9IiMzRDUwRkMiLz4KPHJlY3Qgb3BhY2l0eT0iMC42IiB4PSI1IiB5PSI1IiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHJ4PSIxIiBmaWxsPSIjRDgwQzlBIi8+CjxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iMTAiIHk9IjkiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgcng9IjEiIGZpbGw9IiMwNUExQzkiLz4KPC9zdmc+Cg==";